import { render, staticRenderFns } from "./PickupEform.vue?vue&type=template&id=ba8fab20&scoped=true"
import script from "./PickupEform.vue?vue&type=script&lang=js"
export * from "./PickupEform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8fab20",
  null
  
)

export default component.exports